export default {
      id: "vector-down-usage",
      viewBox: "0 0 10 5",
      url: __webpack_public_path__ + "img/icons.svg#vector-down",
      toString: function () {
        return this.url;
      }
    }